export default __webpack_public_path__ + "static/2000k-4d5e1626d772a88adbcb068bc300bbf2.png";